import Journals from "../views/Journals.vue";
import JournalCard from "../views/JournalCard.vue";
import IppsuCard from "../views/IppsuCard.vue";
import IpraCard from "../views/IpraCard";
import journalWrapper from "@/modules/journal/views/journalWrapper";

export const routes = [
  {
    path: "/journals",
    name: "journalWrapper",
    component: journalWrapper,
    children: [
      {
        path: "",
        name: "Journal",
        component: Journals
      },
      {
        path: ":action/:id/:statusOfChangeId?",
        name: "journalCard",
        component: JournalCard
      }
    ]
  },

  {
    path: "/journal/:patient_id/ippsu/:action/:id?",
    name: "ippsuCard",
    component: IppsuCard
  },
  {
    path: "/journal/:journal_id/ipra/:action/:id?",
    name: "ipraCard",
    component: IpraCard
  }
];
